/**
 * Defines the constants used by the Echo module.
 * @file
 * @author Brendan Miller <brendan@thebrandingfarm.com>
 * @author Benjamin Listwon <ben@thebrandingfarm.com>
 * @author Jason Haddix <jason@thebrandingfarm.com>
 */
export const VUEX_ECHO_INIT                         = 'VUEX_ECHO_INIT'
export const VUEX_ECHO_INITIALIZED                  = 'VUEX_ECHO_INITIALIZED'
export const VUEX_ECHO_HANDLE_MODEL_BROADCAST_EVENT = 'VUEX_ECHO_HANDLE_MODEL_BROADCAST_EVENT'
export const VUEX_ECHO_LOGOUT                         = 'VUEX_ECHO_LOGOUT'
